import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { ContentProvider } from "./lib/content";

import Landing from "./pages/Landing";
import Carta from "./pages/Carta";
import Solicitar from "./pages/Solicitar";
import Contacto from "./pages/Contacto";
import Testimonios from "./pages/Testimonios";
import SobreMi from "./pages/SobreMi";
import Exito from "./pages/Exito";
import Lectura from "./pages/Lectura";
import AdminLogin from "./pages/AdminLogin";
import Admin from "./pages/Admin";
import Registro from "./pages/Registro";
import Ingresar from "./pages/Ingresar";
import Verificar from "./pages/Verificar";
import { Recuperar, Restablecer } from "./pages/Recuperar";
import MiPanel from "./pages/MiPanel";
import { AuthProvider } from "./lib/auth";

function App() {
  return (
    <div className="App">
      <ContentProvider>
        <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/carta" element={<Carta />} />
            <Route path="/solicitar" element={<Solicitar />} />
            <Route path="/contacto" element={<Contacto />} />
            <Route path="/testimonios" element={<Testimonios />} />
            <Route path="/sobre-mi" element={<SobreMi />} />
            <Route path="/exito" element={<Exito />} />
            <Route path="/lectura/:orderId" element={<Lectura />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/registro" element={<Registro />} />
            <Route path="/ingresar" element={<Ingresar />} />
            <Route path="/verificar" element={<Verificar />} />
            <Route path="/recuperar" element={<Recuperar />} />
            <Route path="/restablecer" element={<Restablecer />} />
            <Route path="/mi-panel" element={<MiPanel />} />
          </Routes>
          <Toaster
            theme="dark"
            position="top-right"
            toastOptions={{
              style: {
                background: "#0C0C16",
                border: "1px solid rgba(200,162,200,0.35)",
                color: "#FAFAFA",
                borderRadius: "2px",
                fontFamily: "Outfit, sans-serif",
              },
            }}
          />
        </BrowserRouter>
        </AuthProvider>
      </ContentProvider>
    </div>
  );
}

export default App;
